module.exports = __webpack_public_path__ + "static/media/Kroc-Center.212cdaba.svg";